import { SvgIcon, SvgIconProps } from '@mui/material'

export function CautionIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.75a.75.75 0 0 1 .65.374l11 19A.75.75 0 0 1 23 22.25H1a.75.75 0 0 1-.65-1.126l11-19A.75.75 0 0 1 12 1.75Zm-9.7 19h19.4L12 3.997 2.3 20.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.75a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-1.5 0v-.5a.75.75 0 0 1 .75-.75ZM12 8.75a.75.75 0 0 1 .75.75l.004 5a.75.75 0 0 1-1.5 0l-.004-5a.75.75 0 0 1 .75-.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default CautionIcon
